export default [
    {
        // [0]
        key: "country",
        label: app.$i18n.t("Country"),
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "name",
        label: app.$i18n.t("Name"),
        sortable: true,
        visible: true,
    },
    {
        // [2]
        key: "month",
        label: app.$i18n.t("Month"),
        sortable: true,
        visible: true,
        tdClass: "text-center",
        thClass: "text-center",
    },
    {
        // [3]
        key: "day",
        label: app.$i18n.t("Day"),
        sortable: true,
        visible: true,
        tdClass: "text-center",
        thClass: "text-center",
    },
    {
        // [4]
        key: "is_apply",
        label: app.$i18n.t("Apply Payroll"),
        sortable: true,
        visible: true,
        tdClass: "text-center",
        thClass: "text-center",
    },
    {
        // [5]
        key: "status",
        label: app.$i18n.t("Status"),
        sortable: true,
        visible: true,
        tdClass: "text-center",
        thClass: "text-center",
    },
    {
        // [6]
        key: "created_by",
        label: app.$i18n.t("Created By"),
        sortable: false,
        visible: true,
    },
    {
        // [7]
        key: "actions",
        label: app.$i18n.t("Actions"),
        sortable: false,
        visible: true,
    },
]